// useInView.ts
import { createSignal, onCleanup, onMount } from "solid-js";

export const useInView = (options?: IntersectionObserverInit) => {
  const [inView, setInView] = createSignal(false);
  let observer: IntersectionObserver | null = null;
  let target: Element | undefined;

  const setRef = (el: Element | undefined) => {
    if (observer && target) {
      observer.unobserve(target);
    }
    target = el;

    if (el && observer) {
      observer.observe(el);
    }
  };

  onMount(() => {
    observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      options,
    );

    if (target) {
      observer.observe(target);
    }
  });

  onCleanup(() => {
    if (observer && target) observer.unobserve(target);

    observer?.disconnect();
    observer = null;
  });

  return { inView, setRef };
};
